/** Mirrors PermissionCatalog hiring requisition capabilities. */
export const HiringRequisitionPermissions = {
  raise: 'hiring_requisition_raise',
  hire: 'hiring_requisition_hire',
} as const
